<template>
  <div>
    <v-data-table :headers="headers" :items="items" class="v-card__container" flat>
      <template v-slot:top>        
        <!-- The Dialog -->
        <v-dialog v-model="dialog" max-width="600px">
          <v-card flat>
            <v-form ref="form" :lazy-validation="true">
              <v-card-title>
                <span class="display-1">{{ formTitle }}</span>
              </v-card-title>

              <v-card-actions>
                <v-icon class="close" @click="close">$sl-close</v-icon>
              </v-card-actions>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      :md="Object.keys(editedItem).length > 1 ? '6' : '12'"
                      v-for="(key,i) in Object.keys(editedItem).filter(key => {return key !== 'id'}) "
                      :key="i"
                    >
                      <template v-if="editedItem[key].type === 'text'">
                        <v-text-field
                          outlined
                          v-if="editedItem[key].required"
                          :rules="[rules.required]"
                          v-model="editedItem[key].value"
                          :label="editedItem[key].label"
                        ></v-text-field>
                        <v-text-field
                          outlined
                          v-else
                          v-model="editedItem[key].value"
                          :label="editedItem[key].label"
                        ></v-text-field>
                      </template>

                      <template v-if="editedItem[key].type === 'boolean'">
                        <v-checkbox
                          :false-value="false"
                          :true-value="true"
                          v-model="editedItem[key].value"
                          :label="editedItem[key].label"
                        ></v-checkbox>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="d-flex justify-end">
                <v-btn color="secondary" @click="close">
                  <v-icon>$sl-cancel</v-icon>Avbryt
                </v-btn>
                <v-btn color="primary" class="icon" @click="save">
                  <v-icon>$sl-check</v-icon>Spara
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- <v-toolbar flat color="white">
          <v-toolbar-title class="display-1">{{tableTitle}}</v-toolbar-title>          
          
          
        </v-toolbar>-->
      </template>

      <template v-slot:item.action="{ item }">
        <div style="text-align: right;">
          <v-btn text class="mr-2 px-1" @click="editItem(item)">
            <v-icon text class="mr-2">$sl-edit</v-icon>Ändra
          </v-btn>
          <v-btn text class="mr-2 px-1" @click="deleteItem(item)">
            <v-icon text class="mr-2">$sl-delete</v-icon>Radera
          </v-btn>
        </div>
      </template>

      <!-- TODO theese booleans should be passed in and not hardcoded like this-->
      <template v-slot:item.isMachineProfession="{ item }">
        <v-icon>{{ item.isMachineProfession ? "$sl-check-square" : "$sl-uncheck-square" }}</v-icon>
      </template>
      <!-- Apprenticeship Employment icon-->
      <template v-slot:item.isApprenticeshipEmployment="{ item }">
        <v-icon>{{ item.isApprenticeshipEmployment ? "$sl-check-square" : "$sl-uncheck-square" }}</v-icon>
      </template>
      <!-- Allow Apprentices icon-->
      <template v-slot:item.allowNewApprentices="{ item }">
        <v-icon>{{ item.allowNewApprentices ? "$sl-check-square" : "$sl-uncheck-square" }}</v-icon>
      </template>
    </v-data-table>
    <v-btn absolute bottom right fab @click="newItem">
      <v-icon class="ml-1">$sl-add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import API from '@/services/api.js'
import {log} from 'util'
import {RulesMixin} from '@/components/mixins'
// @group Common
// Styled CrudTable component
export default {
  name: 'CrudTable',

  mixins: [RulesMixin],

  props: {
    //function that needs to be called
    fn: {
      type: String,
      required: true
    },
    //has table an header
    tableTitle: {
      type: String,
      required: true
    },
    //has header properties
    headersProps: {
      type: Array,
      // The default value is: `empty array`
      default: []
    },
    //has default item
    dfltItem: {
      type: Object,
      // The default value is: `empty object`
      default: {}
    }
  },
  data: () => ({
    dialog: false,
    headers: [],
    items: [],
    editedItem: {},
    editedIndex: -1,
    item: {},
    label: ''
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? `Skapa ${this.tableTitle}` : `Redigera ${this.tableTitle}`
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
    this.editedItem = JSON.parse(JSON.stringify(this.dfltItem))
  },

  methods: {
    initialize() {
      API['list' + [this.fn]]()
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    newItem(item) {
      this.editedIndex = -1
      //- Set to "model"
      this.editedItem = JSON.parse(JSON.stringify(this.dfltItem))

      this.dialog = true
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item)

      //- Set to "model"
      this.editedItem = JSON.parse(JSON.stringify(this.dfltItem))
      // @vuese
      //- Set value of model to item value
      Object.keys(this.editedItem).forEach(i => {
        try {
          this.editedItem[i].value = item[i]
        } catch (err) {
          console.log(err)
        }
      })
      this.dialog = true
    },

    async deleteItem(item) {
      const res = await this.$dialog.confirm({
        title: 'Vill du verkligen radera ' + this.tableTitle + '?',
        text: '' ,
        width: '500px',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res === true) {
        const index = this.items.indexOf(item)
        API['delete' + [this.fn]](item.id)
          .then(reponse => {
            this.items.splice(index, 1)
            this.$events.fire('showInfo', 'Raderad.')
          })
          .catch(error => {
            this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
            console.log('There was an error:', error)
          })
      }
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.dfltItem))
        this.editedIndex = -1
      }, 300)
    },

    /**
     * @vuese
     * Used to create or update an list
     * @arg The argument is a object representing data that need to be changed
     */
    save() {
      //- Valid ?
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      //- Extract data field: value KP from model
      let newObj = {}
      Object.keys(this.editedItem).forEach(i => {
        newObj[i] = this.editedItem[i].value
      })

      if (this.editedIndex > -1) {
        //- Existing item

        //- Add Existing id before saving
        newObj.id = this.items[this.editedIndex].id
        API['update' + this.fn](newObj.id, {data: newObj})
          .then(response => {
            Object.assign(this.items[this.editedIndex], newObj)
            this.$events.fire('showInfo', 'Sparad.')
          })
          .catch(error => {
            this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
            console.log('There was an error:', error)
            
          })
      } else {
        //- New item
        API['create' + this.fn]({data: newObj})
          .then(response => {
            this.items.push(response.data)
            this.$events.fire('showInfo', 'Skapad.')
          })
          .catch(error => {
            this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
            console.log('There was an error:', error)
          })
      }
      this.close()
    }
  },
  mounted() {
    this.headers = this.headersProps
  }
}
</script>

<style scoped>
</style>